import { useEffect, useState } from "react";
import { flattenDeep } from "lodash";
import * as yup from "yup";
import { isSubProcess } from "../utilities";

const createYupSchema = (schema, config) => {
  const { id, validationType, type, validations, presentationType, value, pending } = config;

  if (isSubProcess(type)) {
    config.elements.forEach((elem) => createYupSchema(schema, elem));
  } else {
    if (!yup[validationType] || ['file', 'image'].includes(presentationType)) {
      return schema;
    }
    let validator = yup[validationType]();
    validations.forEach(validation => {
      const { params, type } = validation;
      if (!validator[type] || (value && pending && type === 'required')) {
        return;
      }
      validator = validator[type](...params);
    });
    schema[id] = validator;
    return schema;
  }
  return schema;
};

export const useFormValidationSchema = (form, events) => {
  const [validationSchema, setValidationSchema] = useState({});

  useEffect(() => {
    const elements = flattenDeep(form.phases.map((phase) => phase.elements));
    const yupSchema = elements.reduce(createYupSchema, {});
    const validateSchema = yup.object().shape(yupSchema);
    setValidationSchema(validateSchema);
  }, [form, events]);

  return validationSchema;
};
